import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class RouteChangeListener extends Component {
  componentDidMount() {
    const currentPath = this.props.location.pathname;
    const previousPath = sessionStorage.getItem('previousPath');

    this.handleLocationChange(
      currentPath,
      this.props.location.search,
      previousPath
    );

    // Store current path for next navigation
    sessionStorage.setItem('previousPath', currentPath);
  }

  componentDidUpdate(prevProps) {
    const currentPath = this.props.location.pathname;
    const currentSearch = this.props.location.search;

    if (
      prevProps.location.pathname === currentPath &&
      prevProps.location.search === currentSearch
    ) {
      return;
    }

    const previousPath = sessionStorage.getItem('previousPath');

    this.handleLocationChange(currentPath, currentSearch, previousPath);

    sessionStorage.setItem('previousPath', currentPath);
  }

  handleLocationChange = (currentPath, currentSearch, prevPath) => {
    const isPdfViewerRoute = currentPath.startsWith('/pdf-viewer');
    const cameFromPdfViewer = prevPath?.startsWith('/pdf-viewer');

    const params = new URLSearchParams(currentSearch);
    const leave = params.get('leave');

    // Block user if left PDF Viewer
    if (cameFromPdfViewer && !isPdfViewerRoute && leave !== 'true') {
      this.props.history.replace({
        pathname: '/pdf-viewer',
        search: '?leave=true'
      });
    }
  };

  render() {
    return null;
  }
}

export default withRouter(RouteChangeListener);
